import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    fontWeight: "bold",
    "& .MuiButton-label": {
      textTransform: "capitalize",
    },
  },
  secondary: {
    backgroundColor: theme.palette.secondary.main,
    "& .MuiButton-label": {
      color: "#FFFFFF",
    },
  },
  primary: {
    backgroundColor: theme.palette.primary.main,
    "&:hover": {
      backgroundColor: theme.palette.primary.hoverColor,
    },
    "& .MuiButton-label": {
      color: "#FFFFFF",
    },
  },
  disabled: {
    backgroundColor: "#cbc8c8",
    "& .MuiButton-label": {
      color: theme.palette.text.disabled,
    },
  },
}));

export default useStyles;
